import { render, staticRenderFns } from "./DestinationOption.vue?vue&type=template&id=2fd3eda1&scoped=true"
import script from "./DestinationOption.vue?vue&type=script&lang=js"
export * from "./DestinationOption.vue?vue&type=script&lang=js"
import style0 from "./DestinationOption.vue?vue&type=style&index=0&id=2fd3eda1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd3eda1",
  null
  
)

export default component.exports